function header () {
    const header = document.querySelector('.header');

    document.addEventListener('scroll', ()=> {
        window.scrollY >= 10 ? header.classList.add('painted') : header.classList.remove('painted'); 
    });

    const nav = document.querySelector('.nav');
    const navItems = nav.querySelectorAll('.nav__item');
    const navLinks = document.querySelectorAll('.nav__link');
    const burger = document.querySelector('.header__burger');
    
    function navOperation () {
        nav.classList.toggle('show');
        burger.classList.toggle('active');

        if(nav.classList.contains('show')) {
            navItems.forEach((el, i)=> {
                setTimeout(()=> {
                    el.classList.add('anim');
                }, i * 100);
            });
        } else {
            navItems.forEach(el=> {el.classList.remove('anim')});
        }
    }

    burger.addEventListener('click', (e)=> {
        navOperation ();
    });

    navLinks.forEach(el=> {
        el.addEventListener('click', ()=> {
            navOperation ();
        });
    });


    //Lang switch
    const langSwitch = document.querySelector('.header__lang-switch');
    const langList = document.querySelector('.header__lang-list');
    
    langSwitch.addEventListener('click', (e)=> {
        langSwitch.classList.toggle('active');
        langList.classList.toggle('show');
    });
}

export default header;